<svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...$$restProps}>
	<rect x="10" y="24" width="20" height="2" rx="1" fill="currentColor" />
	<rect x="10" y="14" width="20" height="2" rx="1" fill="currentColor" />
</svg>
